import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

function Login(request_body) {
  return request({
    url: API.AUTH.LOGIN,
    method: requestMethods.POST,
    data: {
      email: request_body.email,
      password: request_body.password,
    },
  });
}

function LoginEpno(body) {
  return request({
    url: API.AUTH.LOGIN_EPNO,
    method: requestMethods.POST,
    data: {
      email: body.email,
      password: body.password,
    },
  });
}

function Register(request_body) {
  return request({
    url: API.AUTH.REGISTER,
    method: requestMethods.POST,
    data: request_body,
  }).catch((error) => {
    // Retornar el error para que pueda ser manejado en el componente
    return Promise.reject(error);
  });
}

function PasswordResetRequest(email) {
  return request({
    url: API.AUTH.PASSWORD_RESET,
    method: requestMethods.POST,
    data: {
      email: email,
    },
  });
}

function PasswordReset(token, newPassword) {
  return request({
    url: API.AUTH.PASSWORD_EMAIL,
    method: requestMethods.POST,
    data: {
      token: token,
      newPassword: newPassword
    }
  });
}

function CheckSession() {
  return request({
    url: API.AUTH.CHECK_SESSION,
    method: requestMethods.POST,
  });
}

const AuthService = {
  Login,
  LoginEpno,
  Register,
  CheckSession,
  PasswordResetRequest,
  PasswordReset,
};

export default AuthService;
